/* Rhein Juwelier — Custom Theme JS */

/* ---- Always scroll to top on page load ---- */
if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
window.addEventListener('load', function () { window.scrollTo(0, 0); });

/* ---- Header scroll state ---- */
(function () {
  var header = document.querySelector('.rj-header');
  if (!header) return;

  var alwaysSolid = document.body.classList.contains('template-index');

  function updateHeader() {
    if (alwaysSolid || window.scrollY > 60) {
      header.classList.remove('is-transparent');
      header.classList.add('is-solid');
    } else {
      header.classList.add('is-transparent');
      header.classList.remove('is-solid');
    }
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
})();

/* ---- Mobile menu ---- */
(function () {
  var burger  = document.querySelector('.rj-burger');
  var menu    = document.querySelector('.rj-mobile-menu');
  var closeBtn = document.querySelector('.rj-mobile-menu__close');
  if (!burger || !menu) return;

  burger.addEventListener('click', function () { menu.classList.add('is-open'); });
  if (closeBtn) closeBtn.addEventListener('click', function () { menu.classList.remove('is-open'); });
  menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { menu.classList.remove('is-open'); });
  });
})();

/* ---- Gold / Silver calculator (multi-item) ---- */
(function () {
  var TROY     = 31.1035;
  var goldPg   = null, silverPg = null;
  var itemCount = 0;
  var MAX_ITEMS = 10;

  var GOLD_OPTIONS = [
    { value: '0.333', label: '333er · 8 Karat' },
    { value: '0.375', label: '375er · 9 Karat' },
    { value: '0.585', label: '585er · 14 Karat', selected: true },
    { value: '0.750', label: '750er · 18 Karat' },
    { value: '0.916', label: '916er · 22 Karat' },
    { value: '0.999', label: '999er · 24 Karat (Feingold)' }
  ];
  var SILVER_OPTIONS = [
    { value: '0.800', label: '800er Silber' },
    { value: '0.835', label: '835er Silber' },
    { value: '0.925', label: '925er · Sterling Silber', selected: true },
    { value: '0.999', label: '999er Feinsilber' }
  ];

  function fmt(n, d) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function $id(id) { return document.getElementById(id); }

  function getFactor() {
    var w = $id('rj-calc-widget');
    return w ? (parseFloat(w.dataset.factor) || 85) / 100 : 0.85;
  }

  function buildPuritySelect(metal, selectEl) {
    var opts = metal === 'gold' ? GOLD_OPTIONS : SILVER_OPTIONS;
    selectEl.innerHTML = '';
    opts.forEach(function(o) {
      var opt = document.createElement('option');
      opt.value = o.value;
      opt.textContent = o.label;
      if (o.selected) opt.selected = true;
      selectEl.appendChild(opt);
    });
  }

  function calcItemValue(metal, purity, weight) {
    var pg = metal === 'gold' ? goldPg : silverPg;
    if (!pg || weight <= 0) return null;
    return pg * purity * weight * getFactor();
  }

  function updateItemResult(item) {
    var metalSel  = item.querySelector('.rj-item-metal');
    var puritySel = item.querySelector('.rj-item-purity');
    var weightEl  = item.querySelector('.rj-item-weight');
    var resultEl  = item.querySelector('.rj-calc__item-result');
    var metal  = metalSel ? metalSel.value : 'gold';
    var purity = parseFloat((puritySel || {}).value) || 0;
    var weight = parseFloat((weightEl || {}).value) || 0;
    var val = calcItemValue(metal, purity, weight);
    if (resultEl) {
      resultEl.textContent = val !== null ? '≈ ' + fmt(val, 2) + ' €' : '≈ —';
      resultEl.classList.toggle('has-value', val !== null);
    }
  }

  function recalcAll() {
    var items = document.querySelectorAll('.rj-calc__item');
    var total = 0;
    var anyValue = false;
    items.forEach(function(item) {
      updateItemResult(item);
      var metalSel  = item.querySelector('.rj-item-metal');
      var puritySel = item.querySelector('.rj-item-purity');
      var weightEl  = item.querySelector('.rj-item-weight');
      var metal  = metalSel ? metalSel.value : 'gold';
      var purity = parseFloat((puritySel || {}).value) || 0;
      var weight = parseFloat((weightEl || {}).value) || 0;
      var val = calcItemValue(metal, purity, weight);
      if (val !== null) { total += val; anyValue = true; }
    });
    var totalEl = $id('rj-total-price');
    if (totalEl) totalEl.textContent = anyValue ? fmt(total, 2) + ' €' : '—';
    updateWaBtn(anyValue, total);
  }

  function updateNumbers() {
    var items = document.querySelectorAll('.rj-calc__item');
    items.forEach(function(item, i) {
      var numEl = item.querySelector('.rj-calc__item-num');
      if (numEl) numEl.textContent = 'Artikel ' + (i + 1);
    });
    var removeButtons = document.querySelectorAll('.rj-calc__item-remove');
    removeButtons.forEach(function(btn) {
      btn.style.display = items.length > 1 ? '' : 'none';
    });
    var addBtn = $id('rj-add-item-btn');
    if (addBtn) addBtn.disabled = items.length >= MAX_ITEMS;
  }

  function addItem() {
    var container = $id('rj-calc-items');
    if (!container || itemCount >= MAX_ITEMS) return;

    var item = document.createElement('div');
    item.className = 'rj-calc__item';

    item.innerHTML =
      '<div class="rj-calc__item-header">' +
        '<span class="rj-calc__item-num">Artikel ' + (itemCount + 1) + '</span>' +
        '<button type="button" class="rj-calc__item-remove" aria-label="Artikel entfernen">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="rj-calc__item-fields">' +
        '<div class="rj-field">' +
          '<label>Metall</label>' +
          '<select class="rj-item-metal">' +
            '<option value="gold">Gold</option>' +
            '<option value="silver">Silber</option>' +
          '</select>' +
        '</div>' +
        '<div class="rj-field">' +
          '<label>Reinheit</label>' +
          '<select class="rj-item-purity"></select>' +
        '</div>' +
        '<div class="rj-field">' +
          '<label>Gewicht (g)</label>' +
          '<input type="number" class="rj-item-weight" placeholder="z. B. 10" min="0" step="0.1">' +
        '</div>' +
      '</div>' +
      '<div class="rj-calc__item-result">≈ —</div>';

    container.appendChild(item);
    itemCount++;

    var metalSel  = item.querySelector('.rj-item-metal');
    var puritySel = item.querySelector('.rj-item-purity');
    buildPuritySelect('gold', puritySel);

    metalSel.addEventListener('change', function() {
      buildPuritySelect(this.value, puritySel);
      recalcAll();
    });
    item.querySelectorAll('.rj-item-purity, .rj-item-weight').forEach(function(el) {
      el.addEventListener('input', recalcAll);
    });
    item.querySelector('.rj-calc__item-remove').addEventListener('click', function() {
      item.remove();
      itemCount--;
      updateNumbers();
      recalcAll();
    });

    updateNumbers();
    recalcAll();
  }

  function buildWaMessage(total) {
    var date      = ($id('rj-ticker-date') || {}).textContent || new Date().toLocaleDateString('de-DE');
    var goldStr   = goldPg   ? fmt(goldPg,   2) + ' €/g' : '–';
    var silverStr = silverPg ? fmt(silverPg, 4) + ' €/g' : '–';
    var items     = document.querySelectorAll('.rj-calc__item');
    var lines     = 'Guten Tag,\n\nIch möchte folgende Schmuckstücke kostenlos bewerten lassen:\n';

    items.forEach(function(item, i) {
      var metalSel  = item.querySelector('.rj-item-metal');
      var puritySel = item.querySelector('.rj-item-purity');
      var weightEl  = item.querySelector('.rj-item-weight');
      var metal  = metalSel ? metalSel.value : 'gold';
      var purity = parseFloat((puritySel || {}).value) || 0;
      var weight = parseFloat((weightEl || {}).value) || 0;
      var purityLabel = puritySel ? puritySel.options[puritySel.selectedIndex].text : '';
      var val = calcItemValue(metal, purity, weight);
      if (weight <= 0) return;
      lines += '\n─── Artikel ' + (i + 1) + ' ───' +
               '\n🔹 Metall: ' + (metal === 'gold' ? 'Gold' : 'Silber') +
               '\n🔹 Reinheit: ' + purityLabel +
               '\n🔹 Gewicht: ' + fmt(weight, 1) + ' g' +
               '\n🔹 Geschätzter Wert: ca. ' + (val !== null ? fmt(val, 2) + ' €' : '–') + '*';
    });

    lines += '\n\n════════════════════' +
             '\n💰 Gesamtwert (geschätzt): ca. ' + fmt(total, 2) + ' €*' +
             '\n\n*(Richtwert auf Basis der Tagespreise vom ' + date + ')' +
             '\n   Gold: ' + goldStr + ' · Silber: ' + silverStr +
             '\n\nIch freue mich über eine persönliche Einschätzung. Wann wäre ein Termin möglich?';
    return lines;
  }

  function updateWaBtn(hasResult, total) {
    var btn = $id('rj-wa-calc-btn');
    if (!btn) return;
    if (!hasResult) {
      btn.setAttribute('aria-disabled', 'true');
      btn.href = '#';
      return;
    }
    btn.href = 'https://wa.me/4917670323280?text=' + encodeURIComponent(buildWaMessage(total));
    btn.removeAttribute('aria-disabled');
  }

  function setTicker(goldG, silverG, date) {
    var gEl   = $id('rj-ticker-gold');
    var sEl   = $id('rj-ticker-silver');
    var dEl   = $id('rj-ticker-date');
    var subEl = $id('rj-result-sub');
    if (gEl)   gEl.textContent   = fmt(goldG,   2) + ' €';
    if (sEl)   sEl.textContent   = fmt(silverG, 4) + ' €';
    if (dEl)   dEl.textContent   = date;
    if (subEl) subEl.textContent = 'Gold: ' + fmt(goldG, 2) + ' €/g · Silber: ' + fmt(silverG, 4) + ' €/g';
  }

  function setError(msg) {
    var subEl = $id('rj-result-sub');
    var gEl   = $id('rj-ticker-gold');
    var sEl   = $id('rj-ticker-silver');
    var dEl   = $id('rj-ticker-date');
    if (subEl) subEl.textContent = msg;
    if (gEl)   gEl.textContent   = 'n/v';
    if (sEl)   sEl.textContent   = 'n/v';
    if (dEl)   dEl.textContent   = '—';
  }

  async function fetchPrices() {
    var TROY_OZ = 31.1035;
    var iso = new Date().toISOString().split('T')[0];
    var npm = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@';

    function ep(tag) {
      return {
        gold:   npm + tag + '/v1/currencies/xau.json',
        silver: npm + tag + '/v1/currencies/xag.json',
        parse:  function(gD, sD) {
          return { gold: gD.xau && gD.xau.eur, silver: sD.xag && sD.xag.eur };
        }
      };
    }

    var ENDPOINTS = [
      ep(iso),
      ep('latest'),
      (function() { var y = new Date(); y.setDate(y.getDate() - 1); return ep(y.toISOString().split('T')[0]); })()
    ];

    for (var i = 0; i < ENDPOINTS.length; i++) {
      try {
        var endpoint = ENDPOINTS[i];
        var ctrl  = new AbortController();
        var timer = setTimeout(function() { ctrl.abort(); }, 6000);
        var responses = await Promise.all([
          fetch(endpoint.gold,   { signal: ctrl.signal }),
          fetch(endpoint.silver, { signal: ctrl.signal })
        ]);
        clearTimeout(timer);
        if (!responses[0].ok || !responses[1].ok) continue;
        var gD = await responses[0].json();
        var sD = await responses[1].json();
        var parsed = endpoint.parse(gD, sD);
        if (!parsed.gold || !parsed.silver) continue;
        goldPg   = parsed.gold   / TROY_OZ;
        silverPg = parsed.silver / TROY_OZ;
        setTicker(goldPg, silverPg, new Date().toLocaleDateString('de-DE'));
        recalcAll();
        return;
      } catch(e) { continue; }
    }
    setError('Tagespreise konnten nicht geladen werden. Bitte Seite neu laden.');
  }

  var addBtn = $id('rj-add-item-btn');
  if (addBtn) {
    addBtn.addEventListener('click', addItem);
    addItem(); /* Ersten Artikel einfügen */
    fetchPrices();
  }
})();


/* ---- Product page ---- */
(function () {
  var variantsEl = document.getElementById('rj-variants-json');
  if (!variantsEl) return;

  var variants     = JSON.parse(variantsEl.textContent);
  var form         = document.getElementById('rj-product-form');
  var variantInput = document.getElementById('rj-variant-id');
  var atcBtn       = document.getElementById('rj-atc-btn');
  var priceNow     = document.getElementById('rj-price-now');
  var priceWas     = document.getElementById('rj-price-was');
  var saleBadge    = document.getElementById('rj-sale-badge');
  var stickyPrice  = document.getElementById('rj-sticky-price');
  var stickyAtc    = document.getElementById('rj-sticky-atc-btn');
  var mainImg      = document.getElementById('rj-main-img');

  /* Collect currently selected option values */
  var selected = {};
  document.querySelectorAll('.rj-opt-btn.is-active').forEach(function (btn) {
    selected[btn.dataset.option] = btn.dataset.value;
  });

  function formatMoney(cents) {
    var meta = document.querySelector('meta[name="money-format"]');
    var fmt  = meta ? meta.getAttribute('content') : '{{amount_with_comma_separator}} &euro;';
    var val  = (cents / 100).toFixed(2);
    var withComma = val.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecimals = String(Math.round(cents / 100));
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', val);
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return selected[String(i + 1)] === opt;
      });
    }) || variants[0];
  }

  function applyVariant(v) {
    if (!v) return;
    variantInput.value = v.id;

    /* Price */
    if (priceNow) priceNow.textContent = formatMoney(v.price);
    var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
    if (priceWas)  { priceWas.textContent = hasCompare ? formatMoney(v.compare_at_price) : ''; priceWas.style.display = hasCompare ? '' : 'none'; }
    if (saleBadge) saleBadge.style.display = hasCompare ? '' : 'none';
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);

    /* ATC state */
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
    if (stickyAtc) {
      stickyAtc.disabled = !v.available;
      stickyAtc.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    }

    /* Variant image */
    if (v.featured_image && mainImg) {
      mainImg.src = v.featured_image.src;
      mainImg.srcset = '';
      /* Deactivate thumbs, activate matching one */
      document.querySelectorAll('.rj-pgallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.src && t.dataset.src.includes(v.featured_image.src.split('?')[0].split('/').pop().split('.')[0]));
      });
    }
  }

  /* Option button clicks */
  document.querySelectorAll('.rj-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = this.dataset.option;
      var val = this.dataset.value;
      selected[pos] = val;

      /* Update active state within this option group */
      document.querySelectorAll('.rj-opt-btn[data-option="' + pos + '"]').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.value === val);
      });

      /* Update selected label */
      var label = document.getElementById('rj-opt-val-' + pos);
      if (label) label.textContent = val;

      applyVariant(findVariant());
    });
  });

  /* Gallery thumbnails */
  document.querySelectorAll('.rj-pgallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = this.dataset.src;
      if (this.dataset.srcset) mainImg.srcset = this.dataset.srcset;
      document.querySelectorAll('.rj-pgallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* Sticky CTA trigger */
  var stickyCta = document.getElementById('rj-sticky-cta');
  if (stickyCta && atcBtn) {
    var obs = new IntersectionObserver(function (entries) {
      stickyCta.classList.toggle('is-visible', !entries[0].isIntersecting);
      stickyCta.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }

  /* Sticky CTA button → submit form */
  if (stickyAtc && form) {
    stickyAtc.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();

/* ---- Cart quantity buttons ---- */
(function () {
  document.querySelectorAll('.rj-qty__dec, .rj-qty__inc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.rj-qty').querySelector('input');
      var val = parseInt(input.value) || 1;
      if (this.classList.contains('rj-qty__dec') && val > 1) input.value = val - 1;
      if (this.classList.contains('rj-qty__inc')) input.value = val + 1;
    });
  });
})();

/* ---- Scroll reveal ---- */
(function () {
  var els = document.querySelectorAll('.rj-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
})();
